import { getToDay } from '@/utils/date';
import { message } from 'antd';
import { realTime, aggregate } from '@/services/cost';
import moment from 'moment';

let [startDate] = getToDay();

export default {
  namespace: 'nowrate',
  state: {
    searchParams: {
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      lineName: undefined,
      lineType: 2,
      transportLineType: ['长线', '短线', '支线'],
      taskNo: undefined,
      taskAttribute: '',
      transportStatus: '',
    },

    page: 1,
    pageSize: 50,
    total: 0,

    onSearch: false,
    tableDatas: [],
    // calcWeightCount: 0, // 结算重量之和
    // volumeCount: 0, // 体积之和
    // actualCapacityCount: 0, // 实际运力之和
    // actualPositionCount: 0, // 实际仓位之和

    actualCapacity: 0, // 实际运力之和
    totalCalcWeightRate: 0, // 结算装载率
    totalCalcWeight: 0, // 结算重量之和
    totalVolume: 0, // 体积之和
    totalVolumeRate: 0, // 体积装载率

    exportVisible: false,

    access: {
      isHead: false,
      isArea: false,
      isCenter: true,
      code: '',
    },
  },

  effects: {
    // 分页查询
    *getDatas(_, { call, put, select }) {
      const nowrate = yield select(({ nowrate }) => nowrate);
      const { searchParams, access } = nowrate;
      const {
        departureCenter,
        arrivalCenter,
        transportLineType,
        lineName,
        lineType,
        taskNo,
        taskAttribute,
        startDate,
        endDate,
        maxRatio, // 结算装载率范围
        minRatio, // 结算装载率范围
      } = searchParams;

      if (!access.isHead) {
        if (!departureCenter) {
          throw new Error('请选择出发站点/营运区');
        }
      }
      // 查询条件写死了
      const result = yield call(realTime, {});
      let tableDatas = [];
      if (result?.code === 1 && result?.data) {
        let arr = [...result?.data];
        // 过滤数据
        if (result?.data && result?.data.length > 0) {
          arr.forEach((item) => {
            let list = [];
            // 任务号
            if (taskNo && taskNo.length > 0) {
              if (item?.taskNo === taskNo) {
              } else {
                list.push('false');
              }
            }
            // 计划线路
            if (lineType === 2) {
              if (lineName && lineName.length > 0) {
                if (item?.shiftName && item?.shiftName.includes(lineName)) {
                } else {
                  list.push('false');
                }
              }
            }
            // 实际线路
            if (lineType === 1) {
              if (lineName && lineName.length > 0) {
                if (item?.lineName && item?.lineName.includes(lineName)) {
                } else {
                  list.push('false');
                }
              }
            }
            // 出发组织
            if (departureCenter) {
              const directlist = item?.direction.split('-');
              if (
                directlist[0] ===
                departureCenter.name.replace(/分拨中心|经营本部|省区|营运区|管理区/g, '')
              ) {
              } else {
                list.push('false');
              }
            }
            // 到达组织
            if (arrivalCenter) {
              const directlist = item?.direction.split('-');
              if (
                directlist[1] ===
                arrivalCenter.name.replace(/分拨中心|经营本部|省区|营运区|管理区/g, '')
              ) {
              } else {
                list.push('false');
              }
            }
            // 线路类型
            if (transportLineType && transportLineType.length > 0) {
              if (
                item?.transportLineType &&
                transportLineType.join().includes(item?.transportLineType)
              ) {
              } else {
                list.push('false');
              }
            }
            // 班次性质
            if (taskAttribute) {
              if (item?.taskAttribute === taskAttribute) {
              } else {
                list.push('false');
              }
            }
            if (minRatio) {
              if (item?.totalCalcWeightRate && minRatio < Number(item?.totalCalcWeightRate)) {
              } else {
                list.push('false');
              }
            }
            if (maxRatio) {
              if (item?.totalCalcWeightRate && maxRatio > Number(item?.totalCalcWeightRate)) {
              } else {
                list.push('false');
              }
            }

            if (list.length > 0) {
            } else {
              tableDatas.push(item);
            }
          });
        }

        yield put({
          type: 'updateState',
          payload: {
            tableDatas,
            total: tableDatas.length || 0,
          },
        });
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};
